function escapeHtml(str) {
    var div = document.createElement('div');
    div.appendChild(document.createTextNode(str));
    return div.innerHTML;
}

var integrationTitles = {
    wasapbom: 'WasapBom Integration',
    wabot: 'Wabot Integration',
    wasapbot: 'WasapBot Integration',
    smsniaga: 'SMS Niaga Integration',
    mailniaga_v1: 'Mail Niaga V1 Integration',
    mailniaga_v2: 'Mail Niaga V2 Integration',
    google_sheets: 'Google Sheets'
};

var testUrl = '';
var csrfToken = '';
var integrationUrls = {};

window.initIntegrations = function(url, token, urls) {
    testUrl = url;
    csrfToken = token;
    integrationUrls = urls || {};
    initToggles();
};

function initToggles() {
    $('.toggle-fields').each(function() {
        var toggleId = $(this).data('toggle-for');
        var $fields = $(this);
        var $checkbox = $('#' + toggleId);

        function toggle() {
            var enabled = $checkbox.is(':checked');
            $fields.find('input, textarea, select, button').prop('disabled', !enabled);
            $fields.css('opacity', enabled ? 1 : 0.5);
        }

        $checkbox.on('change', toggle);
        toggle();
    });
}

window.openIntegrationPanel = function(key) {
    $('#testResult').hide();
    $('.integration-fields').hide();
    $('.integration-fields[data-integration="' + key + '"]').show();
    $('#integrationKey').val(key);
    $('#integrationPanelTitle').text(integrationTitles[key] || 'Setup');
    $('#integrationFormButtons').toggle(key !== 'google_sheets');
    var $el = $('#integrationSlideover');
    $el.css('visibility', 'visible');
    requestAnimationFrame(function() { $el.addClass('show'); });
    initToggles();

    if (key === 'smsniaga') {
        fetchSmsNiagaSenderIds();
    }
};

window.closeIntegrationPanel = function() {
    var $el = $('#integrationSlideover');
    $el.removeClass('show');
    setTimeout(function() { $el.css('visibility', 'hidden'); }, 260);
};

$(document).on('click', '.btn-test-connection', function() {
    var $btn = $(this);
    var currentKey = $('#integrationKey').val();
    var $result = $('#testResult');
    var originalHtml = $btn.html();
    var params = { integration: currentKey };

    switch (currentKey) {
        case 'wasapbom':
            params.token = $('[name="wasapbom_token"]').val();
            break;
        case 'wabot':
            params.token = $('[name="wabot_access_token"]').val();
            params.instance_id = $('[name="wabot_instance_id"]').val();
            break;
        case 'wasapbot':
            params.token = $('[name="wasapbot_access_token"]').val();
            params.instance_id = $('[name="wasapbot_instance_id"]').val();
            break;
        case 'smsniaga':
            params.token = $('[name="sms_token"]').val();
            break;
        case 'mailniaga_v1':
            params.token = $('[name="mailniaga_v1_api_key"]').val();
            params.brand_id = $('[name="mailniaga_v1_brand_id"]').val();
            break;
        case 'mailniaga_v2':
            params.token = $('[name="mailniaga_v2_api_token"]').val();
            break;
    }

    $btn.prop('disabled', true).html('<i class="fad fa-spinner-third fa-spin mr-1"></i> Testing...');
    $result.hide();

    $.ajax({
        url: testUrl,
        method: 'POST',
        data: params,
        headers: { 'X-CSRF-TOKEN': csrfToken },
        dataType: 'json',
        success: function(res) {
            $result
                .removeClass('alert-success alert-danger alert-warning')
                .addClass(res.success ? 'alert-success' : 'alert-danger')
                .html((res.success ? '<i class="fad fa-check-circle mr-1"></i>' : '<i class="fad fa-times-circle mr-1"></i>') + escapeHtml(res.message))
                .show();

            if (res.success && res.phone_number && currentKey === 'wasapbom') {
                var $adminField = $('[name="wasapbom_admin_number"]');
                if (!$adminField.val()) {
                    $adminField.val(res.phone_number);
                }
            }

            if (res.success && res.sender_ids && currentKey === 'smsniaga') {
                populateSmsNiagaSenderIds(res.sender_ids);
            }
        },
        error: function() {
            $result
                .removeClass('alert-success alert-danger')
                .addClass('alert-danger')
                .html('<i class="fad fa-times-circle mr-1"></i> Request failed. Please try again.')
                .show();
        },
        complete: function() {
            $btn.prop('disabled', false).html(originalHtml);
        }
    });
});

$(document).keydown(function(e) {
    if (e.key === 'Escape') closeIntegrationPanel();
});

function populateSmsNiagaSenderIds(senderIds) {
    var $sel = $('[name="sms_sender_id"]');
    var current = $sel.val();
    $sel.html('<option value="">-- Select Sender ID --</option>');
    $.each(senderIds, function(key, val) {
        $sel.append('<option value="' + key + '"' + (key === current ? ' selected' : '') + '>' + val + '</option>');
    });
}

function fetchSmsNiagaSenderIds() {
    if (!integrationUrls.smsNiagaSenderIdsUrl) return;
    var $sel = $('[name="sms_sender_id"]');
    if ($sel.find('option').length > 1) return;

    $sel.html('<option value="">-- Loading... --</option>');
    $.get(integrationUrls.smsNiagaSenderIdsUrl).done(function(data) {
        populateSmsNiagaSenderIds(data);
    }).fail(function() {
        $sel.html('<option value="">-- Verify token first --</option>');
    });
}
